<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">订单管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;" @click="$router.go(-1)">订单列表</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">订单详情</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>


        <!-- 上半部分 -->
        <div class="detailContent">
            <div class="upperInfoContent">
                <div class="title">
                    <span class="name"><span v-if="orderdetail.orderpage.username">{{orderdetail.orderpage.username}}</span>
                    <span class="name" v-else>--</span></span>
                    <a-tag color="orange" v-if="orderdetail.orderpage.state==0">未发货</a-tag>
                    <a-tag color="blue" v-if="orderdetail.orderpage.state==1">已发货</a-tag>
                    <a-tag color="green" v-if="orderdetail.orderpage.state==2">已接受</a-tag>
                </div>

                <div class="fieldContainer">
                    <div class="fieldItem">
                        <span>手机：</span>
                        <span v-if="orderdetail.orderpage.telephone"><a href="javascript:;">{{orderdetail.orderpage.telephone}}</a></span>
                        <span v-else>--</span>
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>地址：</span>
                        <span v-if="orderdetail.orderpage.province">{{orderdetail.orderpage.province}}{{orderdetail.orderpage.city}}{{orderdetail.orderpage.area}}{{orderdetail.orderpage.address}}</span>
                        <span v-else>--</span>   
                    </div>
                    <a-divider type="vertical" />
                </div>

                <div class="fieldContainer" style="padding-top:0">
                     <div class="fieldItem">
                        <span>发货时间：</span>
                        <span v-if="orderdetail.orderpage.sendtime">{{orderdetail.orderpage.sendtime|formatDate}}</span>
                        <span v-else>--</span>
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>收货时间：</span>
                        <span v-if="orderdetail.orderpage.receivtime">{{orderdetail.orderpage.receivtime}}</span>
                        <span v-else>--</span>
                    </div>
                </div>

                <div class="btnListContainer" >
                    <a-button  type="primary" @click="openfh(orderdetail.clueid,2)"><a-icon type="export" />发货</a-button>
                </div>
            </div>
        </div>

        <!-- 下半部分 -->
        <div class="lowerInfoContent">
            <div class="basicinfo">
                
                <div class="information">
                    <div class="informationLeft" ref="informationLeft">
                        <div class="title">
                            <img src="../../../static/flag.png" alt="">
                            <span>基本信息</span>
                        </div>
                        <a-descriptions bordered :column="2" :size="size">
                            <a-descriptions-item label="订单编号">
                            {{orderdetail.orderpage.orderno}}
                            </a-descriptions-item>
                            <a-descriptions-item label="购卡数量">
                            {{orderdetail.orderpage.num}}
                            </a-descriptions-item>
                            <a-descriptions-item label="支付状态">
                                <a-tag v-if="orderdetail.orderpage.state_pay==0" color="orange">未支付</a-tag>
                                <a-tag v-if="orderdetail.orderpage.state_pay==1" color="green">已支付</a-tag>
                                <a-tag v-if="orderdetail.orderpage.state_pay==3" color="blue">已退款</a-tag>
                            </a-descriptions-item>
                             <a-descriptions-item label="快递单号">
                            {{orderdetail.orderpage.tracknumber}}
                            </a-descriptions-item>
                            <a-descriptions-item label="姓名">
                            {{orderdetail.orderpage.username}}
                            </a-descriptions-item>
                            <a-descriptions-item label="电话">
                            {{orderdetail.orderpage.telephone}}
                            </a-descriptions-item>

                            <a-descriptions-item label="地址" :span="3">
                            {{orderdetail.orderpage.province}}{{orderdetail.orderpage.city}}{{orderdetail.orderpage.area}}{{orderdetail.orderpage.address}}
                            </a-descriptions-item>

                            <a-descriptions-item label="状态">
                                <a-tag v-if="orderdetail.orderpage.state==0" color="orange">未发货</a-tag>
                                <a-tag v-if="orderdetail.orderpage.state==1" color="green">已发货</a-tag>
                                <a-tag v-if="orderdetail.orderpage.state==2" color="blue">已接受</a-tag>
                                <a-tag v-if="orderdetail.orderpage.state==3" color="orange">拒收</a-tag>
                            </a-descriptions-item>
                            <a-descriptions-item label="添加日期">
                            <span v-if="orderdetail.orderpage.addtime">
                                {{orderdetail.orderpage.addtime|showDate}}
                            </span> 
                            </a-descriptions-item>
                            <a-descriptions-item label="发货日期">
                            <span v-if="orderdetail.orderpage.sendtime">
                                {{orderdetail.orderpage.sendtime|showDate}}
                            </span> 
                            </a-descriptions-item>
                            <a-descriptions-item label="收货日期">
                            <span v-if="orderdetail.orderpage.receivtime">
                                {{orderdetail.orderpage.receivtime}}
                            </span>
                            </a-descriptions-item>
                            
                        </a-descriptions>

                        <div class="title" style="margin-top:20px">
                            <img src="../../../static/flag.png" alt="">
                            <span>发货单</span>
                        </div>

                        <div class="devlierlist">
                            <a-empty description="未发货" v-if="orderdetail.goodslist.length==0"/>
                            <div v-else :style="{width:width}">
                                <a-carousel>

                                    <div v-for="item in orderdetail.goodslist"  :key="item.gdid">
                                        <a-form class="dataform" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                                            <a-form-item label="ID">
                                                <a-input disabled :value="item.gdid"/>
                                            </a-form-item>
                                            <a-form-item label="电话号码">
                                                <a-input disabled :value="item.telephone"/>
                                            </a-form-item>
                                            <a-form-item label="ICCID">
                                                <a-input disabled :value="item.iccid"/>
                                            </a-form-item>

                                        </a-form>
                                    </div>

                                   
                                </a-carousel>
                            </div>
                        </div>

                    </div>
                    <div class="informationRight">
                        <div class="title">
                            <img src="../../../static/flag.png" alt="">
                            <span>订单状态</span>
                        </div>
                        <a-timeline v-if="data_logistics">
                            <div v-for="(item,i) in data_logistics" :key="i">
                                <a-timeline-item >
                                    <span slot="dot" class="steps-index-TimeDot"></span>
                                    <div class="date-arrow">{{item.time}}</div>
                                </a-timeline-item>
                                <a-timeline-item>
                                    <div class="description">
                                        <div class="dataContainer">
                                            <span class="follow-date"><a-icon type="clock-circle"/>{{item.time}}</span>
                                            <div class="gjcontent">{{item.context}}</div> 
                                        </div>
                                    </div>
                                </a-timeline-item>
                            </div>
                        </a-timeline>
                        <a-empty v-else description="暂无数据"/>
                    </div>
                </div>
                 
            </div>
        </div>

        <!-- 发货 -->
        <a-modal
        title="发货"
        :visible="delivevisible"
        @cancel="handleCancel"
        cancelText="取消"
        okText="发货"
        @ok="khhandleOk"
        >
            <div class="deliver" >

                <div class="orderinfo">
                    <span class="title">姓名：</span><span>{{orderdetail.orderpage.username}}</span>
                    <span class="title" style="margin-left: 20px;">电话：</span><span>{{orderdetail.orderpage.telephone}}</span>
                    <span class="title" style="margin-left: 20px;">卡数：</span><span>{{orderdetail.orderpage.num}}</span>
                    <p><span class="title">地址：</span>{{orderdetail.orderpage.province}}{{orderdetail.orderpage.city}}{{orderdetail.orderpage.area}}{{orderdetail.orderpage.address}}</p>
                </div>
                <a-form class="dataform" :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
                    <!-- <a-form-item label="快递单号" >
                        <a-input v-model="orderdetail.orderpage.orderno" disabled=""/>
                    </a-form-item> -->

                    <a-form-item label="订单号" >
                        <a-input v-model="orderdetail.orderpage.orderno" disabled=""/>
                    </a-form-item>
                    <a-form-item label="快递单号" >
                        <a-input v-model="orderdetail.orderpage.tracknumber" />
                    </a-form-item>


                    <div v-for="(i) in bottom" :key="i.gdid">
                        <a-form-item label="手机号" ref="telephone" >
                            <a-input v-model="i.telephone" />
                        </a-form-item>
                        <a-form-item label="ICCID" ref="iccid" >
                            <a-input v-model="i.iccid" />
                        </a-form-item>
                        <a-divider />
                    </div>
                    <!-- <a-form-item label="ICCID" ref="iccid" v-for="(i) in bottom" :key="i.gdid">
                          <a-form-item label="手机号" ref="telephone" >
                            <a-input v-model="i.telephone" />
                        </a-form-item>
                        <a-input v-model="i.iccid" />
                    </a-form-item> -->
                </a-form>
            </div>
            
        </a-modal>
    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      },

       showDate(time){
          time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd hh:mm:ss')
      }
    },
    props: {
		inputNums: {
			type: Number,
			default: 19
		},
		value: {
			type: String,
			default: ''
		}
	},
    data(){
        return{
            code: this.value.split(''),
            delivevisible:false,
            form: this.$form.createForm(this, { name: 'coordinated' }),
            ordernum:[],
            position:0,
            iccidlist:[],
            editvisible:false,
            numshow:true,
            form: this.$form.createForm(this, { name: 'coordinated' }),
            gjrecord:[{date:'2021-06-07',add_time:'2021-06-07',user_name:'admin',content:'跟进内容'}],
            size:'middle',

            fhdlist:[{iccid:'1234567890123456789'}],
            width:'560px',
            dotPosition:'bottom',
            orid:"",
            orderdetail:"",

            top:{
                orid:"",
                state:1,
                tracknumber:""
            },
            bottom:[],
            data_logistics:""
        }
    },
    watch: {
        value(newVal){
                this.code = newVal.split('');
        },
        code(newVal){
            this.$emit('input',newVal.join(''));
        }
    },

    mounted(){

        // this.width=this.$refs.informationLeft.offsetWidth+'px'
        this.orid=this.$route.query.id
        this.top.orid=this.$route.query.id

        this.getdetail()
        // console.log(this.width)
        // this.width=this.$refs.informationLeft.clientWidth + "px"
    },
    methods:{

        getdetail(){
            this.$axios.post('/api/order/orderpage',{
                orid:this.orid
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.orderdetail=res.data.data
                    if(res.data.data.data_logistics){
                        this.data_logistics=eval('(' + res.data.data.data_logistics + ')')
                    }
                    // console.log(this.data_logistics)
                    var goodslist=res.data.data.goodslist
                    for(var i in goodslist){
                        this.$delete(goodslist[i], 'goodsname')
                        this.$delete(goodslist[i], 'orid')
                        this.$delete(goodslist[i], 'state')
                        this.$delete(goodslist[i], 'updatetime')
                        this.$delete(goodslist[i], 'addtime')
                    }
                    this.bottom=goodslist
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

        // 拨打电话
        call(id){

        },

        // 跟进线索
        handleCancel(){
            this.editvisible=false
        },
        tokehu(){
            this.editvisible=true
        },
        khhandleOk(){
            this.top.tracknumber=this.orderdetail.orderpage.tracknumber
            this.$axios.post('/api/order/delivergoods',{
                order:this.top,
                goodslist:this.bottom
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                    this.getdetail()
                    this.delivevisible=false
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        sexSelectChange(){

        },
        ondateChange(date, dateString) {
            console.log(date, dateString);
        },
        ontypeChange(e) {
            if( e.target.value==0){
                this.numshow=true
            }else if( e.target.value==1){
                this.numshow=false
            }
        },
         // 上一张
        prev(x){
            this.position--;
            console.log(this.iccidlist)
        },

        // 下一张
        next(x){
            this.position++;
            this.iccidlist[x]=this.iccidlist[x]
        },


         // 发货
        openfh(id,num){
            this.delivevisible=true
                       for(var i=0;i<num;i++){
                this.ordernum.push({"i":i})
            }
            console.log(this.ordernum)
        },
        fahuo(){

        },
        todelive(id,num){
            this.delivevisible=true
            for(var i=0;i<num;i++){
                this.ordernum.push({"i":i})
            }
            console.log(this.ordernum)
     
        },

        handleCancel(){
            this.delivevisible=false
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/order/orderdetail.vue